export const HIGHEST_NUMBER = 99999999;

export const PERCENT_INPUT_TYPE = "Percent";
export const PERCENT_MIN = 0;
export const PERCENT_MAX = 100;
export const PERCENT_DECIMALS = 2;
export const PERCENT_DELTA = 0.01;

export const UNIT_INPUT_TYPE = "Unit";
export const UNIT_MIN = 0;
export const UNIT_MAX = HIGHEST_NUMBER;
export const UNIT_DECIMALS = 1;
export const UNIT_DELTA = 1;

export const DOLLAR_INPUT_TYPE = "Dollar";
export const DOLLAR_MIN = 0;
export const DOLLAR_MAX = HIGHEST_NUMBER;
export const DOLLAR_DECIMALS = 2;
export const DOLLAR_DELTA = 0.01;

export const DOLLAR_PER_UNIT_INPUT_TYPE = "Dollar per Unit";
export const DOLLAR_PER_DAY_INPUT_TYPE = "Dollar per Day";

export const INPUT_SX = { width: "95px" };
